module.exports = __webpack_public_path__ + "static/img/welfare-opened-bg.97dce11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/welfare-opened-bg.png
// module id = ljtG
// module chunks = 212